import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

const main = new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')


export default main;
